'use client';

// The backstop. Catches anything no closer boundary caught, for any route that
// does not have its own error.tsx.
//
// It is NOT the product: the buyer tour (app/t/[slug]/error.tsx) and the agent's
// listing screens (app/agent/listings/[id]/error.tsx) each catch first, because
// they know who is standing in front of them. Reaching this file means we did
// not anticipate the surface, so the copy commits to nothing about their work.
//
// A root-layout throw does NOT reach here. That is global-error.tsx.

import './vireo.css';
import { ErrorSurface } from './_components/vireo/ErrorSurface';
import { useErrorReport, type BoundaryError } from './_lib/diag/use-error-report';

export default function RootError({ error, reset }: { error: BoundaryError; reset: () => void }) {
  useErrorReport(error, 'root');

  return (
    <ErrorSurface
      eyebrow="Something went wrong"
      heading="That did not go to plan."
      // No claim about saved work: this boundary does not know what screen it
      // is standing in for, and a promise it cannot keep is worse than silence.
      sub="The page hit an error we did not expect. It has been reported. Trying again often clears it, and the map is always there."
      onRetry={reset}
      secondaryHref="/"
      secondaryLabel="Back to the map"
    />
  );
}
